<template>
  <v-container>
    <v-card class="transparent ma-7" height="100%" width="100%" flat>
      <v-card-text>
        <v-card-title class="mb-5 text-h5 font-weight-black _light_grey--text">{{ filterSubject }}</v-card-title>
        <v-row justify="start" align="center">
          <v-card v-for="data in filterList" v-show="filterList.length" class="ma-4" :key="data.id">
            <CardV :data="data" :key="data.name" @click="cardHandler(data.name)" />
          </v-card>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';
import CardV from '../components/CardV.vue';

export default {
  name: 'FilterList',
  props: {},
  components: { CardV },
  data: () => ({}),
  computed: {
    ...mapState('dbTable', ['filterList', 'filterSubject']),
  },
  created() {
    if (!this.filterSubject) {
      this.$router.push({ name: 'main' });
    }
  },
  methods: {
    cardHandler(productName) {
      this.$router.push({ name: 'cardDetail', params: { productName } });
    },
  },
};
</script>
